import React, { Component } from "react";
import { Button, Divider, Form, Upload, message } from 'antd';
// import { NHSelect, NHFormItem, NHCheckBox } from "xgui-for-react";
import NHSelect from "../common/NHSelect";
import NHFormItem from "../common/NHFormItem";
import NHCheckBox from '../common/NHCheckBox';

/**
 * 批量上传照片
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2019-06-11 
 * Version: 1.0
 * Modify log:
 */
class UploadPhoto extends Component {
    constructor(props) {
        super(props);
        this.state = {
            photoNameType: '学号',
            fileList: [],
            fileName: [],
        }
    }

    /**
     * * 照片命名格式
     * @memberof UploadPhoto
     */
    onSelect = (value, label) => {
        this.setState({ photoNameType: label });
    }

    //上传前调用方法
    beforeUpload(file) {
        if (file.type === "") {
            if (file.name.indexOf(".zip") === -1 && file.name.indexOf(".rar") === -1) {
                message.error('只能上传 .zip 、.rar 格式压缩文件');
                return false;
            } else {
                return true;
            }
        } else {
            if (file.type.indexOf('zip') === -1 && file.type.indexOf('rar') === -1) {
                message.error('只能上传 .zip 、.rar 格式压缩文件');
                return false;
            } else {
                return true;
            }
        }
    }

    //上传改变触发事件
    onChange = (info) => {
        let fileList = [...info.fileList];
        // 过滤掉未上传成功的文件
        fileList = fileList.filter((file) => {
            if (file.response) {
                return file.response.code === 200;
            } else {
                return false;
            }
        });
        info.fileList = fileList;
        const form = this.props.form;
        const { setFieldsValue } = form;
        this.setState({ fileList: fileList });
        setFieldsValue({ file: fileList });
    }

    render() {

        const { photoNameType } = this.state;

        const { form } = this.props;

        const showUploadList={
            showDownloadIcon:false
        }
        const uploadProp = {
            accept: '.zip,.rar',
            action: 'api/sm-student/studentPhotoMng/uploadTempFile',//上传地址
            showUploadList:showUploadList,
            multiple: false, //支持多选文件
            name: 'file', //发到后台的文件参数名
            beforeUpload: this.beforeUpload,//上传文件之前的钩子，参数为上传的文件
            onChange: this.onChange
        };

        let tip = <span>{`例：${photoNameType}.jpg、${photoNameType}.png等`}</span>;

        return (
            <div>
                <div style={{ color: "#f5222d" }}>
                    <div>1、只能导入.zip格式压缩包。</div>
                    <div>2、单次上传压缩包大小最大为100MB。</div>
                    <div>3、请将照片放在文件夹中统一压缩，或全选照片后添加到压缩文件。</div>
                    <div>4、如果照片命名格式与所选的格式不符，则上传时会被忽略。</div>
                </div>
                <Divider />
                <div style={{ margin: "16px" }}>
                    <Form>
                        <NHFormItem id={"zhlx"} label={"照片命名格式"} required={true} form={form} tip={tip} initialValue={'xh'}>
                            <NHSelect sign={"zhxg_xsxx_xszhlx_select"} onSelect={this.onSelect} />
                        </NHFormItem>
                        <NHFormItem id={"zplx"} label={"照片类型"} required={true} form={form}>
                            <NHCheckBox sign={"DMK_XSXX_ZPLXM"} />
                        </NHFormItem>
                        <NHFormItem id={"file"} label={"照片压缩包"} required={true} form={form}>
                            <Upload {...uploadProp}>
                                <Button>点击上传</Button>
                            </Upload>
                        </NHFormItem>
                    </Form>
                </div>
            </div>
        )
    }
}

const UploadForm = Form.create()(UploadPhoto);
export default UploadForm;


// WEBPACK FOOTER //
// ./components/studentPhotoMng/UploadForm.js